import {useQuery} from "@tanstack/react-query";
import {
    DistributedRewardResponse,
    RewardsApi,
    Token,
} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchDistributedReward(distributedRewardId: string, fullToken?: Token): Promise<DistributedRewardResponse> {
    return await new RewardsApi(getConfig(fullToken)).getDistributedRewardSingle({
        id: distributedRewardId,
    });
}

function getDistributedRewardQuery(distributedRewardId: string, fullToken?: Token) {
    return {
        queryKey: [
            "get-distributed-reward",
            distributedRewardId,
            fullToken?.id ?? "unauthenticated",
        ],
        queryFn: () => fetchDistributedReward(distributedRewardId, fullToken),
        staleTime: 60000,
        enabled: Boolean(distributedRewardId),
    } as const;
}

export function useGetDistributedReward(distributedRewardId: string, fullToken?: Token) {
    return useQuery(getDistributedRewardQuery(distributedRewardId, fullToken));
}
